import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  reportId?: string;
}

export const useDownloadBatchReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, reportId }: HookProps) => {
      const result = await apiClient.batchesReports.downloadBatchReport.mutation({ body: { batchId, reportId } });
      if (result.status !== 200) throw result.body;

      const href = window.URL.createObjectURL(result.body as Blob);
      const link = document.createElement('a');
      link.href = href;

      const [, fileName] = /attachment; filename="(.*)"/i.exec(result.headers.get('content-disposition'));

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('Successfully downloaded batch report!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading batch report!');
    },
  });
};
